import { Message, Button, Icon, Table, Container } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { server, socket } from "../../../App";

import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { useSelector } from "react-redux";
import { payment_axios_func } from "../../Api/api";
import { useNavigate, useLocation } from "react-router-dom";

function PaymentAct(props) {
  const [myLocation, setMylocation] = useState();

  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const patientelleState = useSelector(selectPatientelleGrid);
  const location = useLocation();
  const {
    civilite,
    nom,
    prenom,
    commentaire_sur_patient,
    date_naissance,
    idpatient,
    fk_id_patient1,
  } = patientelleState;

  sessionStorage.setItem("ID_Session", idpatient);

  useEffect(() => {
    setMylocation(location.pathname);
  }, [location]);

  const { data, refetch } = useQuery(
    "Get_Payment",
    () => {
      return payment_axios_func(fk_id_patient1 ? fk_id_patient1 : idpatient);
    },
    {
      cacheTime: 1,
    }
  );
  // const { data: data_At_date, refetch: refetch_At_date } = useQuery(
  //   "Get_Payment_at_Date",
  //   () => {
  //     let data = {
  //       id: fk_id_patient1,
  //       // id: fk_id_patient1 ? fk_id_patient1 : idpatient,
  //       date: moment().format("YYYY-MM-DD"),
  //     };
  //     return paymentAt_Date_axios_func(data);
  //   },
  //   {
  //     cacheTime: 1,
  //   }
  // );

  useEffect(() => {
    function receivedMessage(m) {
      refetch();
    }

    socket.on("add", receivedMessage);
    socket.on("update", receivedMessage);
    socket.on("transfer", receivedMessage);
    return () => {
      socket.off("add", receivedMessage);
      socket.off("update", receivedMessage);
      socket.off("transfer", receivedMessage);
    };
    // eslint-disable-next-line
  }, []);

  const onSubmit = async (data) => {
    //
    axios({
      method: "put",
      responseType: "json",
      url: `${server}actes/updateActe`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        socket.emit("update", {
          civilite,
          nom,
          prenom,
          actionTypeSocket: "a été encaissé",
        });
        toast.success("Successfully created", {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // THIS IS TRUE DONT CHANGE THE DATE FORMAT
  let date_naissance_to_origin = moment(date_naissance).format("YYYY-DD-MM");
  let years = moment().diff(date_naissance_to_origin, "years", false);
  let months = moment().diff(date_naissance_to_origin, "months", false);
  let age;
  if (years === 0) {
    age = months;
  } else {
    age = years;
  }

  return (
    <Container>
      {myLocation === "/Consultation" ? null : (
        <>
          <br></br>
          <h1>Vous pouvez encaisser une ou plusieurs prestations</h1>
          <h3>
            JE SUIS {civilite} {nom} {prenom} <br></br> Age : {age}
          </h3>
          <br></br>
        </>
      )}

      {commentaire_sur_patient ? (
        <Message color="red">
          <Message.Header>Important!</Message.Header>
          {commentaire_sur_patient}
        </Message>
      ) : null}
      {myLocation === "/Consultation" ? null : <br></br>}
      <Table
        // definition
        // celled
        // fixed
        // singleLine
        // striped
        // selectable
        // textAlign="center"
        definition
        celled
        fixed
        // singleLine
        striped
        selectable
        textAlign="center"
        size="small"
        // unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>date consultation</Table.HeaderCell>
            <Table.HeaderCell>Tarif normal</Table.HeaderCell>
            <Table.HeaderCell>Supplement</Table.HeaderCell>
            <Table.HeaderCell>Remise</Table.HeaderCell>
            <Table.HeaderCell>Paiement</Table.HeaderCell>
            <Table.HeaderCell>reste à payer</Table.HeaderCell>
            <Table.HeaderCell>créé le</Table.HeaderCell>
            <Table.HeaderCell>modifié le</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {/* {data_At_date?.map((item, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{item.nom_acte}</Table.Cell>
              <Table.Cell>{item.date_consultation}</Table.Cell>
              <Table.Cell>
                {item.prix_acte}
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_patient1}
                  {...register(`${idx}-fk_id_patient1`)}
                />

                <input
                  hidden={true}
                  defaultValue={
                    myLocation === "/Consultation"
                      ? moment().format("YYYY-MM-DD")
                      : item.dateConsuServer
                  }
                  // type="date"
                  // name="date_consultation"
                  // min="1900-01-01"
                  // max="3018-12-31"
                  {...register(`${idx}-date_consultation`)}
                ></input>
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_acte}
                  {...register(`${idx}-fk_id_acte`)}
                />
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.suplement}
                      {...register(`${idx}-suplement`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.remise}
                      {...register(`${idx}-remise`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.payment}
                      {...register(`${idx}-payment`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell
                className={
                  item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment ===
                  0
                    ? "paid"
                    : item.prix_acte +
                        item.suplement -
                        item.remise -
                        item.payment >
                      0
                    ? "unpaid"
                    : item.prix_acte +
                        item.suplement -
                        item.remise -
                        item.payment <
                      0
                    ? "overPaid"
                    : null
                }
              >
                {item.prix_acte +
                  item.suplement -
                  item.remise -
                  item.payment ===
                0 ? (
                  <Icon name="checkmark" color="green" size="large" />
                ) : item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment >
                  0 ? (
                  <Icon name="attention" color="red" size="large" />
                ) : item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment <
                  0 ? (
                  <Icon name="close" color="black" size="large" />
                ) : null}
                {item.prix_acte + item.suplement - item.remise - item.payment}
              </Table.Cell>

              <Table.Cell>{item.created_at}</Table.Cell>
              <Table.Cell>{item.updated_at}</Table.Cell>
            </Table.Row>
          ))} */}

          {data?.map((item, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{item.nom_acte}</Table.Cell>
              <Table.Cell>{item.date_consultation}</Table.Cell>
              <Table.Cell>
                {item.prix_acte}
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_patient1}
                  {...register(`${idx}-fk_id_patient1`)}
                />

                <input
                  hidden={true}
                  defaultValue={
                    myLocation === "/Consultation"
                      ? moment().format("YYYY-MM-DD")
                      : item.dateConsuServer
                  }
                  // type="date"
                  // name="date_consultation"
                  // min="1900-01-01"
                  // max="3018-12-31"
                  {...register(`${idx}-date_consultation`)}
                ></input>
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_acte}
                  {...register(`${idx}-fk_id_acte`)}
                />
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.suplement}
                      {...register(`${idx}-suplement`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.remise}
                      {...register(`${idx}-remise`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.payment}
                      {...register(`${idx}-payment`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell
                className={
                  item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment ===
                  0
                    ? "paid"
                    : item.prix_acte +
                        item.suplement -
                        item.remise -
                        item.payment >
                      0
                    ? "unpaid"
                    : item.prix_acte +
                        item.suplement -
                        item.remise -
                        item.payment <
                      0
                    ? "overPaid"
                    : null
                }
              >
                {item.prix_acte +
                  item.suplement -
                  item.remise -
                  item.payment ===
                0 ? (
                  <Icon name="checkmark" color="green" size="large" />
                ) : item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment >
                  0 ? (
                  <Icon name="attention" color="red" size="large" />
                ) : item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment <
                  0 ? (
                  <Icon name="close" color="black" size="large" />
                ) : null}
                {item.prix_acte + item.suplement - item.remise - item.payment}
              </Table.Cell>

              <Table.Cell>{item.created_at}</Table.Cell>
              <Table.Cell>{item.updated_at}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan="8">
              {myLocation === "/Consultation" ? null : (
                <Button
                  floated="right"
                  color="violet"
                  onClick={() => navigate(-1)}
                >
                  Retour
                </Button>
              )}

              <Button
                // floated="right"
                animated
                positive
                onClick={handleSubmit(onSubmit)}
              >
                <Button.Content visible>Encaisser</Button.Content>
                <Button.Content hidden>
                  <Icon
                    name="dollar sign"
                    color="yellow"
                    className="IconFix"
                    size="big"
                  />
                </Button.Content>
              </Button>
              {/* <Button
                floated="left"
                color="orange"
                onClick={GoToActActPatientGridDone}
              >
                Accomplie
              </Button>
              <Button floated="left" color="teal" onClick={GoToActPatientGrid}>
                liste d'attente
              </Button>
              <Button
                floated="left"
                color="violet"
                onClick={GoToPatientelleGrid}
              >
                Patientelle
              </Button> */}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Container>
  );
}

export default PaymentAct;
